import { render, staticRenderFns } from "./entrust-dialog.vue?vue&type=template&id=57b3c54f&scoped=true&"
import script from "./entrust-dialog.vue?vue&type=script&lang=js&"
export * from "./entrust-dialog.vue?vue&type=script&lang=js&"
import style0 from "./entrust-dialog.vue?vue&type=style&index=0&id=57b3c54f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b3c54f",
  null
  
)

export default component.exports